import { Icon } from "@mui/material";
import { UserPermissions } from "generated/graphql";
import AuthWall from "modules/AuthWall/AuthWall";
import AuthWallSubscriber from "modules/AuthWallSubscriber/AuthWallSubscriber";

import CompaniesPage from "pages/companies";
import OpportunitiesPage from "pages/opportunities";
import TasksPage from "pages/tasks";

const crmRoutes = [
  {
    type: "collapse",
    name: "CRM",
    key: "crm",
    icon: <Icon fontSize="medium">group</Icon>,
    collapse: [
      {
        name: "Contacts",
        key: "crm.contacts",
        route: "/companies",
        permission: UserPermissions.VIEW_COMPANIES,
        component: (
          <AuthWall permission={UserPermissions.VIEW_COMPANIES}>
            <AuthWallSubscriber>
              <CompaniesPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Opportunities",
        key: "crm.opportunities",
        route: "/opportunities",
        permission: [
          UserPermissions.VIEW_OPPORTUNITIES,
          UserPermissions.VIEW_ONLY_ASSIGNED_OPPORTUNITIES,
        ],
        component: (
          <AuthWall
            permission={[
              UserPermissions.VIEW_OPPORTUNITIES,
              UserPermissions.VIEW_ONLY_ASSIGNED_OPPORTUNITIES,
            ]}
          >
            <AuthWallSubscriber>
              <OpportunitiesPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Tasks",
        key: "tasks.list",
        route: "/tasks",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <TasksPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
    ],
  },
] as const;

export default crmRoutes;
